"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractApiClient = void 0;
const tslib_1 = require("tslib");
class AbstractApiClient {
    constructor(params) {
        this.params = params;
    }
    getBaseUrl() {
        const { parent, baseUrl } = this.params;
        return (parent === null || parent === void 0 ? void 0 : parent.getBaseUrl()) || baseUrl;
    }
    getDefaultReqOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const parent = this.params.parent;
            if (!parent) {
                throw Error('getDefaultReqOptions(..) must be overridden if client has no parent');
            }
            return parent.getDefaultReqOptions();
        });
    }
    getChildParams() {
        return {
            parent: this,
        };
    }
}
exports.AbstractApiClient = AbstractApiClient;
//# sourceMappingURL=api-client.js.map